import { GetTripResponse } from "Application/models";
import { APICallInstance } from "./APICallInstance";
import { AxiosResponse } from "axios";


export const getTripData = async () => {
    const url = 'api/v1/trip';

    try {
        const response: AxiosResponse<GetTripResponse> = await APICallInstance.get(url);
        console.log(response)
        return response.data;
    } catch (error) {
        throw error;
    }
}
